<template>
	<div id="cliente">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="20">
				<a-input-search					
					v-model="strSearch"
					:maxLength=100
					placeholder="Insira o texto a ser pesquisado"
					@search="onSearch"					
					:disabled="loading"
				>
					<a-button slot="enterButton" type="primary" :disabled="loading">Pesquisar</a-button>
				</a-input-search>
			</a-col>
			<a-col :span="4" style="text-align: right;">
				<a-button
					type="primary"						
					class="tr-search-btn"
					style="width: 130px;"
					@click.stop.prevent="onNewCliente"
					:disabled="loading"
					v-if="habilitarFuncionalidade('PermitirIncluir')"
				>Novo Cliente</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idCliente"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template slot="status" slot-scope="status, record">					
					<a-icon type="check-circle" class="sucess" v-if="record.status"/>
					<a-icon type="close-circle" class="danger" v-else/>					
				</template>
				<template slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar cliente</template>
							<a-icon 
								type="form" 
								class="cursor"
								@click="editarCliente(record)"/>
						</a-tooltip>
					</div>
				</template>
			</a-table>

			<modal-component
				class="modal-component"
				title="Editar Cliente"
				ref="modalcli"
				width="50%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Nome:</span>
					<a-input
						:maxLength=100
						placeholder="Insira o nome do cliente"
						v-model="cliente.nome"
						v-ant-input-focus
						:allowClear="cliente.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">E-mail:</span>					
					<a-input
						:maxLength=100
						placeholder="Insira o e-mail do cliente" 
						v-model="cliente.email"
						:allowClear="cliente.email!=''"
					>
						<a-icon slot="prefix" type="mail"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Login Faturamento:</span>					
					<a-input
						:maxLength=50
						placeholder="Insira o login Faturamento da rede do cliente" 
						v-model="cliente.loginFaturamento" 
						:allowClear="cliente.loginFaturamento!=''"
					>
						<a-icon slot="prefix" type="team"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Tipo Envio E-mail:</span>
				</a-row>
				<a-row>
					<a-select style="width: 190px" :value="valueEnvioEmail" @change="handleSelectChange">
						<a-select-option
								v-for="tpEnvioEmail in tpEnvioEmailData"
								:key="tpEnvioEmail.key"
								:value="tpEnvioEmail.key"
							>{{tpEnvioEmail.descricao}}</a-select-option>
						</a-select>
				</a-row>				
				<a-row>
					<span>Usuário da API:</span>					
					<a-input
						:maxLength=50
						placeholder="Insira o Usuário da API o do cliente"
						v-model="cliente.usuarioAPI"
						:allowClear="cliente.usuarioAPI!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span>Senha da API:</span>					
					<a-input-password
						:maxLength=30
						ref='editSenhaAPI'
						placeholder="Insira a Senha da API o do cliente"
						v-model="cliente.senhaAPI"
						:allowClear="cliente.senhaAPI!=''"
					>
						<a-icon slot="prefix" type="lock"/>
					</a-input-password>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">
							<a-switch style="margin-left: 15px;" defaultChecked v-model="cliente.status" @change="handlerSwitchChange">
								<a-icon type="check" slot="checkedChildren"/>
								<a-icon type="close" slot="unCheckedChildren"/>
							</a-switch>
							<span style="margin-left: 10px;">Situação</span>
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="cliente-form-button" @click.prevent="handleCancel">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="cliente-form-button"
										type="primary"
										@click.prevent="handleOkEditCli"
										v-if="habilitarFuncionalidade('PermitirAlterar')"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</span>
			</modal-component>

			<modal-component
				class="modal-component"				
				title="Novo Cliente"
				ref="modalnewcli"
				width="50%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Nome:</span>					
					<a-input
						:maxLength=100
						placeholder="Insira o nome do cliente"
						v-model="cliente.nome"						
						v-ant-input-focus
						:allowClear="cliente.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">E-mail:</span>					
					<a-input 
						:maxLength=100
						placeholder="Insira o e-mail do cliente" 
						v-model="cliente.email"
						:allowClear="cliente.email!=''"
					>
						<a-icon slot="prefix" type="mail"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Login Faturamento:</span>					
					<a-input
						:maxLength=50
						placeholder="Insira o login Faturamento do cliente"
						v-model="cliente.loginFaturamento"						
						@change="lowerCase"
						:allowClear="cliente.loginFaturamento!=''"
					>
						<a-icon slot="prefix" type="team"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Tipo Envio E-mail:</span>
				</a-row>
				<a-row>
					<a-select style="width: 190px" :value="valueEnvioEmail" @change="handleSelectChange">
						<a-select-option
								v-for="tpEnvioEmail in tpEnvioEmailData"
								:key="tpEnvioEmail.key"
								:value="tpEnvioEmail.key"
							>{{tpEnvioEmail.descricao}}</a-select-option>
						</a-select>
				</a-row>
				<a-row>
					<span>Usuário da API:</span>					
					<a-input
						:maxLength=50
						placeholder="Insira o Usuário da API o do cliente"
						v-model="cliente.usuarioAPI"
						:allowClear="cliente.usuarioAPI!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span>Senha da API:</span>					
					<a-input-password
						:maxLength=30
						ref='newSenhaAPI'
						placeholder="Insira a Senha da API o do cliente"
						v-model="cliente.senhaAPI"
						:allowClear="cliente.senhaAPI!=''"
					>
						<a-icon slot="prefix" type="lock"/>
					</a-input-password>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">														
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="cliente-form-button" @click.prevent="handleCancelNewCli">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="cliente-form-button"
										type="primary"
										@click.prevent="handleOkNewCli"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>					
				</span>
			</modal-component>
		</a-row>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const tpEnvioEmailData = [{ key:1, descricao:"Cliente" }, { key:2, descricao:"Usuários" }, { key:3, descricao:"Cliente e Usuários" }];

const columns = [
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),
		//width: "20%",
		scopedSlots: { customRender: "nome" }
	},
	{
		title: "Email",
		dataIndex: "email",
		sorter: (a, b) => a.email.localeCompare(b.email),
		width: "23%",
		scopedSlots: { customRender: "email" }
	},
	{
		title: "Situação",
		dataIndex: "status",
		width: "10%",
		sorter: (a, b) => a.status - b.status,
		align: "center",
		scopedSlots: { customRender: "status" }
	},
	{
		title: "Login Faturamento",
		dataIndex: "loginFaturamento",
		sorter: (a, b) => a.loginFaturamento.localeCompare(b.loginFaturamento),
		width: "23%",
		scopedSlots: { customRender: "loginFaturamento" }
	},
	{
		key: "IdCliente",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "10%",
		scopedSlots: { customRender: "editar" }
	}
];

export default {	
	name: "cliente",
	data() {
		return {
			idTela: 2,
			data: [],
			tpEnvioEmailData,
			strSearch: null,
			searchText: "",
			searchInput: null,
			pagination: {},
			loading: false,
			columns,
			cliente: {
				idCliente: 0,
				nome: "",
				email: "",
				status: true,
				loginFaturamento: "",
				idUsuarioCadastro: 0,
				idUsuarioUltimaAlteracao: 0,
				tipoEnvioEmail: 0,
				usuarioAPI: undefined,
				senhaAPI: undefined
			},
			perfisPortalCompleto: [],
			perfisPortal: [],
			valueEnvioEmail: null,
			oldStatus: true,
		};
	},
	mounted() {
		this.fetch({ search: true, IdPerfilPortal: this.$store.state.auth.idPerfilPortal });
		this.recuperarPerfisPortal();		
	},
	methods: {
		lowerCase() {
            this.cliente.loginFaturamento = this.cliente.loginFaturamento.toLowerCase();
        },
		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		handleSelectChange(value) {
			this.valueEnvioEmail = value;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		fetch(params = {}) {
			this.loading = true;
			if (params.search) {
				IntimacaoWebApi.getClisExibicao(params).then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Cliente", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Cliente", res.data.result);
					} else {
						this.data = res.data.result;
						this.pagination = { current: 1 };
					}
				});
			} else {
				this.loading = false;
			}
		},
		onSearch(text) {
			this.fetch({ search: true, Text: text, IdPerfilPortal: this.$store.state.auth.idPerfilPortal });
		},
		validarCampos(cliente){
			let camposValidos = true
			
			if(cliente.nome == ""){
				showNotificationError(this, "Cadastro de Cliente", "Nome é um campo obrigatório!");
				camposValidos = false;
			}else if (cliente.email == ""){
				showNotificationError(this, "Cadastro de Cliente", "Email é um campo obrigatório!");
				camposValidos = false;	
			}else if (cliente.loginFaturamento == ""){
				showNotificationError(this, "Cadastro de Cliente", "Login Faturamento é um campo obrigatório!");
				camposValidos = false;
			}else if (this.valueEnvioEmail == null){
				showNotificationError(this, "Cadastro de Cliente", "Tipo Envio E-mail é um campo obrigatório!");
				camposValidos = false;
			}else if ((cliente.senhaAPI != undefined && cliente.senhaAPI != "") && 
					(cliente.usuarioAPI == undefined || cliente.usuarioAPI == "")){
				showNotificationError(this, "Cadastro de Cliente", "Usuário da API não pode ser nula!");
				camposValidos = false;
			}else if ((cliente.usuarioAPI != undefined && cliente.usuarioAPI != "") && 
					(cliente.senhaAPI == undefined || cliente.senhaAPI == "")){
				showNotificationError(this, "Cadastro de Cliente", "Senha da API não pode ser nula!");
				camposValidos = false;
			}

			return camposValidos;
		},
		editarCliente(cliente) {
			this.cliente.idCliente = cliente.idCliente;
			this.cliente.nome = cliente.nome;
			this.cliente.email = cliente.email;
			this.cliente.status = cliente.status;
			this.oldStatus = cliente.status;
			this.cliente.loginFaturamento = cliente.loginFaturamento;
			this.cliente.tipoEnvioEmail = cliente.tipoEnvioEmail;
			this.valueEnvioEmail = cliente.tipoEnvioEmail;
			this.cliente.usuarioAPI = cliente.usuarioAPI;
			this.cliente.senhaAPI = cliente.senhaAPI;
			if (this.$refs.editSenhaAPI != undefined)
				this.$refs.editSenhaAPI.visible = false;
			this.$refs.modalcli.showModal();
		},
		onNewCliente() {
			this.handleCancel();
			this.perfisPortal = this.$store.state.auth.idPerfilPortal != 1 ? this.perfisPortalCompleto.filter(y => {
				return y.idPerfilPortal != 1;
			}) : this.perfisPortalCompleto;
			if (this.$refs.newSenhaAPI != undefined)
				this.$refs.newSenhaAPI.visible = false;
			this.$refs.modalnewcli.showModal();
		},
		recuperarPerfisPortal() {
			IntimacaoWebApi.getPerfisPortal().then(res => {
				this.perfisPortalCompleto = res.data.result;
				this.perfisPortal = res.data.result;
			});
		},
		handleOkEditCli(e) {
			if(!this.validarCampos(this.cliente)){
				return
			};

			if ((this.oldStatus == true) && (this.cliente.status == false)) {
				const _this = this;
				const x = _this.$createElement;				
				this.$confirm({				
					title: x('div', {}, [
							x('p', "Ao desativar o cliente, todos os usuários, perfis e fontes vinculados a ele serão desativados consequentemente."),
						]),					
					content: h => <div style="font-size: 16px; color: #000000d9;">Deseja continuar?</div>,
					okText: 'Sim',        			
        			cancelText: 'Não',
					width: '25%',
					onOk() {
						_this.chamarAPIEditarCliente();
					},
					onCancel() {},
				});
			} else {
				this.chamarAPIEditarCliente();
			}			
		},
		chamarAPIEditarCliente() {
			this.cliente.tipoEnvioEmail = this.valueEnvioEmail == null ? 0 : this.valueEnvioEmail;
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.atualizarCliente(this.cliente, this.$store.state.auth.idUser)
				.then(res => {
					this.$refs.modalcli.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Cliente", res.data.result);
						this.fetch({ search: true, IdPerfilPortal: this.$store.state.auth.idPerfilPortal });
					} else
						showNotificationError(this, "Cadastro de Cliente", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Cliente", "Erro ao tentar editar cliente.");
				});
		},
		handleCancel() {
			this.$refs.modalcli.handleCancel();
			this.cliente.idCliente = 0;
			this.cliente.nome = "";
			this.cliente.email = "";
			this.cliente.status = true;
			this.cliente.loginFaturamento = "";
			this.cliente.idUsuarioCadastro = 0;
			this.cliente.idUsuarioUltimaAlteracao = 0;
			this.cliente.tipoEnvioEmail = 0;
			this.valueEnvioEmail = null;
			this.cliente.usuarioAPI = undefined;
			this.cliente.senhaAPI = undefined;
		},
		handleOkNewCli() {
			if(!this.validarCampos(this.cliente)){
				return
			}
			this.cliente.idUsuarioCadastro = this.$store.state.auth.idUser;
			this.cliente.status = true;
			this.cliente.tipoEnvioEmail = this.valueEnvioEmail == null ? 0 : this.valueEnvioEmail;
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.inserirCliente(this.cliente)
				.then(res => {
					this.$refs.modalnewcli.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {						
						showNotificationSucess(this, "Cadastro de Cliente", res.data.result);
						this.fetch({ search: true, IdPerfilPortal: this.$store.state.auth.idPerfilPortal });
					} else
						showNotificationError(this, "Cadastro de Cliente", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Cliente", "Erro ao tentar inserir cliente.");
				});
		},
		handleCancelNewCli() {
			this.$refs.modalnewcli.handleCancel();
			this.cliente.idCliente = 0;
			this.cliente.nome = "";
			this.cliente.email = "";
			this.cliente.status = true;
			this.cliente.idUsuarioCadastro = 0;
			this.cliente.idUsuarioUltimaAlteracao = 0;
			this.cliente.tipoEnvioEmail = 0;
			this.valueEnvioEmail = null;
			this.cliente.usuarioAPI = undefined;
			this.cliente.senhaAPI = undefined;
		},
		handleSearch(selectedKeys, confirm) {
			confirm();
			this.searchText = selectedKeys[0];
		},
		handlerSwitchChange(value) {
			this.cliente.status = value;
		},
	},
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.ant-input-affix-wrapper {
	margin: 0px 0px 10px 0px;
} 

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
.cliente-form-button {
	width: 100px;
}
</style>